<template>
  <div class="mask">
    <div id="chatRobot" class="chatRobot" v-animationStart>
      <div class="left-aside" ref="leftAside">
        <div class="btn-wrap">
          <el-button class="button" @click="createdNew">创建新会话</el-button>
        </div>
        <div class="list-wrap">
          <div class="item-single" v-for="item in historyList" :key="item">
            <img
              class="icon"
              src="../../components/chatRobot/image/his-icon.png"
              alt=""
            />
            <div class="title">{{ item.question }}</div>
            <el-dropdown @command="handleCommand($event, item)">
              <img
                class="icon"
                src="../../components/chatRobot/image/more.png"
                alt=""
              />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="detail">详情</el-dropdown-item>
                <el-dropdown-item command="del">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <div class="main" style="flex: 1;">
        <div class="back-head">
          <i
            ref="back_btn"
            class="back-icon el-icon-back"
            @click="goBackInitialize"
          ></i>
        </div>
        <init-page
          ref="initPage"
          @dialogue="openDialogue"
          @returnList="returnList"
          @againProblem="againProblem"
          @getContent="initPageGetContent"
        ></init-page>
        <!--  -->
        <chat-robot-input
          ref="chatRobotInput"
          @content="getCentent"
          :isLock="isLock"
          :isQa="isQa"
        ></chat-robot-input>
      </div>
    </div>
  </div>
</template>

<script>
import initPage from '../../components/chatRobot/initPage/index.vue'
import chatRobotInput from '../../components/chatRobot/chatRobotInput/index.vue'
export default {
  data() {
    return {
      historyList: [],
      contentList: [],
      writeType: '',
      itemId: '',
      activeId: 1,
      isEdit: false,
      isLock: false,
      sessionId: '',
      chatUid: '',
      isQa: 1
    }
  },
  directives: {
    animationStart: {
      inserted: (el) => {
        let fn = () => {
          setTimeout(() => {
            el.style.transition = 'all 0s'
          }, 350)
        }
        setTimeout(() => {
          el.classList.add('flip-up1')
          fn()
        }, 100)
      }
    }
  },
  components: { chatRobotInput, initPage },
  computed: {
    chatShowWrite() {
      return {
        chatUid: this.chatUid,
        sessionId: this.sessionId,
        isQa: this.isQa
      }
    }
  },
  watch: {
    chatShowWrite: {
      handler(val) {
        if (val.chatUid) {
          this.getHistoryList()
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.chatShowWrite) {
      // this.goWrite()
    } else {
      this.activeId = 1
    }
    let chatUid = localStorage.getItem('chatUid')
    if (chatUid) {
      console.log('chatUid:', chatUid)
      this.chatUid = chatUid
    } else {
      this.getChatUid()
    }
  },

  methods: {
    getHistoryList() {
      if (this.chatUid && this.isQa) {
        this.httpGet(`/qa/list`, {
          uid: this.chatUid,
          type: this.isQa
        })
          .then((result) => {
            this.historyList = result.list || []
          })
          .catch(() => {})
      }
    },

    handleCommand(e, item) {
      if (e === 'del') {
        this.deleteHandler(item)
      } else if (e === 'detail') {
        this.getDetail(item)
      }
    },

    deleteHandler(item) {
      this.httpPost('/qa/delete', {
        uid: item.uid,
        session: item.session,
        type: item.type
      })
        .then((result) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        })
        .catch(() => {})
    },
    getDetail(item) {
      this.httpGet(`/qa/detail`, {
        uid: item.uid,
        type: item.type,
        session: item.session
      })
        .then((result) => {
          let list = result.list
          if (list.length > 0) {
            this.$refs.initPage.clearList()
            this.sessionId = list[0].session
          }
          for (let i = list.length - 1; i >= 0; i--) {
            let item = list[i]

            this.init({
              value: item.question,
              type: 1
            })
            this.init({
              type: 2,
              value: '',
              flag: 'start'
            })
            this.init({
              type: 2,
              value: item.answer
            })
            this.init({
              type: 2,
              value: '',
              flag: 'end'
            })
          }
        })
        .catch(() => {})
    },
    // 获取uid
    getChatUid() {
      this.httpGet('/qa/generateuid')
        .then((result) => {
          if (result.uid) {
            this.chatUid = result.uid
            localStorage.setItem('chatUid', result.uid)
          }
        })
        .catch(() => {})
    },

    // 获取会话session
    async getChatSession() {
      await this.httpGet(`/qa/generatesession?uid=${this.chatUid}`)
        .then((result) => {
          if (result.session) {
            this.sessionId = result.session
          }
        })
        .catch(() => {})
    },
    // 创建新会话
    createdNew() {
      this.getChatSession()
      this.$refs.initPage.clearList()
      this.$nextTick(() => {
        this.init({
          type: 2,
          value: '您好，我是智能问答助手，请问有什么可以帮助您的吗？',
          flag: 'start',
          isDefault: true
        })
      })
    },

    goBackInitialize() {
      // this.$refs.initPage.isShow = true
      this.$refs.initPage.close()
      this.$refs.chatRobotInput.close()
      this.$refs.leftAside.style.display = 'none'
      this.$refs.initPage.clearList()
      this.$refs.back_btn.style.display = 'none'
    },
    returnList(res) {
      this.history = res
    },
    initPageGetContent(res) {
      return this.$refs.chatRobotInput.inputContent(res)
    },
    openDialogue(isQa) {
      this.isQa = isQa
      this.getHistoryList()
      let dom = document.getElementById('home')
      if (dom) {
        dom.classList.add('flip-up')
        setTimeout(() => {
          this.$refs.initPage.cl()
          this.init({
            type: 2,
            value: `您好，我是智能${
              isQa === 1 ? '问答助手' : '写作助手'
            }，请问有什么可以帮助您的吗？`,
            flag: 'start',
            isDefault: true
          })
        }, 1000)
      }
      this.$refs.back_btn.style.display = 'flex'

      // 历史
      this.$refs.leftAside.style.display = 'block'
      this.$refs.chatRobotInput.open()
    },
    //  弹窗关闭
    loadingClose() {
      let dom = document.getElementById('chatRobot')
      dom.style.transition = 'all 0.3s'
      dom.classList.add('flip-none')
      setTimeout(() => {
        return this.$emit('chat_close')
      }, 300)

      // let dom1 = document.getElementById('rightMask')
      // dom1.style.transition = 'all 0.3s'
      // dom1.classList.add('flip-none')
      // setTimeout(() => {
      //   return this.$emit('chat_close')
      // }, 300)
    },
    // 重新回答问题
    againProblem(Problem) {
      this.getCentent({ question: Problem })
      // alert('11')
    },
    //  enter回调
    async getCentent(val) {
      if (!this.sessionId) {
        await this.getChatSession()
      }
      /* eslint-disable */
      let dom = document.getElementById('home')
      if (dom) {
        dom.classList.add('flip-up')
        setTimeout(() => {
          this.$refs.initPage.cl()
          this.init({
            value: val.question,
            type: 1
          })
        }, 1000)
      } else {
        this.init({
          value: val.question,
          type: 1
        })
      }
      // this.$getDictLabel('OA_CHAT_GPT', 'key')
      let list = {
        // knowledge_base_id: val.knowledge_base_id,
        // question_source: 1,
        question: val.question,
        renew: false,
        session: this.sessionId,
        uid: Number(this.chatUid),
        type: this.isQa //问答模式 1.对话 2.写作
        // history: this.historyList,
        // creator: 'test',
        // stream: false,
        // temperature: 0.7,
        // local_doc_url: true,
        // question_source: 1,
        // top_k: 5,
        // score_threshold: 0.5
      }
      /* eslint-disable */
      setTimeout(() => {
        workerSend(JSON.stringify(list))
      }, 2000)
      this.isLock = true

      // this.$http.post('/ika/local_doc_chat', { ...list }).then(({ data: res }) => {
      //   this.historyList = res.history
      //   return this.init({ value: res.response, source_documents: res.source_documents, type: 2, qa_id: res.qa_id })
      // })
    },
    /**
     * @description:前往主题或者大纲
     * @return {*}
     */
    getWrite(val, id, isEdit) {
      this.writeType = val
      this.itemId = id
      this.isEdit = isEdit
      this.$refs.initPage.cl()
      this.$refs.chatRobot.cl()
      this.$refs.chatRobotIndex.cl()
      this.$refs.chatRobotInput.isShow = false
      this.$refs.initPage.isShowAll = false
    },

    goBack() {
      this.itemId = ''
      this.$refs.chatRobotIndex.cl()
      this.$refs.chatRobot.init()
      this.$refs.chatRobot.getMore()
      this.activeId = 2
      this.$refs.initPage.cl()
      this.$refs.chatRobot.cl()
      this.$refs.chatRobotInput.isShow = false
      this.$refs.initPage.isShowAll = false
    },
    //  init
    init(res) {
      return this.$refs.initPage.init(res)
    }
  },
  created() {
    let that = this
    /* eslint-disable */
    init('ws://www.cfbchina.org.cn/qa/ask', '', function(res) {
      console.log('created', res)
      if (res.isTrusted) {
        if (res.data === '[[START]]') {
          that.init({
            value: res.data,
            // source_documents: res.source_documents,
            type: 2,
            // qa_id: res.qa_id,
            flag: 'start'
          })
        } else if (res.data === '[[STOP]]') {
          that.init({
            value: res.data,
            // source_documents: res.source_documents,
            type: 2,
            // qa_id: res.qa_id,
            flag: 'end'
          })
          that.isLock = false
        } else {
          that.init({
            value: res.data,
            // source_documents: res.source_documents,
            type: 2
            // qa_id: res.qa_id
          })
        }
      } else {
        that.init({
          value: '网络错误',
          type: 2
        })
        that.isLock = false
      }
    })
  },

  beforeDestroy() {
    webClose()
  }
}
</script>

<style lang="stylus" scoped>
    @import '~assets/main.styl';

      /*定义了滚动条整体样式；*/
      ::-webkit-scrollbar {
      height: 6px !important;
      width: 6px !important;
      background-color: rgba(240, 240, 240, 1);
    }

    /*定义了轨道的样式*/

    ::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.8);
      border-radius: 10px;
      background-color: rgba(240, 240, 240, 1);
    }
    /*定义了滚动条滑块的样式*/
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.7);
      background-color: rgb(179, 176, 176);
    }

    ::-webkit-scrollbar-thumb:hover {
      background: rgb(202, 209, 224);
    }
.left-aside{
  width:280px;
  min-width 280px;
  height:100%;
  display none
  position:relative;
  // background: linear-gradient(90deg,  #BEDAFB 0%,#C6E4FC 100%);
  background #f6f6f6;
  border-right 1px solid #fff;

  .btn-wrap{
    height:60px;
    text-align:center;
    display flex ;
    align-items:center;
    justify-content:center;
    border-bottom 1px solid #F1F3F4
    .button{
      margin 0 auto
    }
  }
  .list-wrap{
    height calc(100% - 60px);
    overflow-y :auto;
    padding 10px 10px;
    padding-bottom 30px
    box-sizing: border-box
    .item-single{
      padding 0 10px
      display flex ;
      height value;
      height 40px;
      align-items:center;
      cursor pointer
      margin-bottom 10px
      .icon{
        width 15px;
        height 15px;
      }
      &:hover{
        background:#fff;
        border-radius 5px;
      }
      .title{
        margin 0 10px;
        flex 1;
        ellipsis()
      }
    }
  }

  }
.mask {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;

  .rightMask {
    position: relative;
    top: -218px;

    p {
      margin: 0px;
      color: #ffffff;
    }

    img {
      margin-bottom: 6px;
    }

    .question1 {
      width: 32px;
      height: 98px;
      border-radius: 0px 16px 16px 0px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // transform: perspective(20px) rotateX(10deg);
    }

    // .question::before{
    //   position: relative;
    // top: -16px;
    // right: -1px;
    // height: 0px;
    // border-top: 14px solid rgba(0, 0, 0, 0.7);
    // border-left: 30px solid transparent;
    // content: "";
    // }
    // .question::after{
    //   position: relative;
    // top: -16px;
    // right: -1px;
    // height: 0px;
    // border-bottom: 14px solid rgba(0, 0, 0, 0.7);
    // border-left: 30px solid transparent;
    // content: "";
    // }

    .questionActive {
      background: #325aff;
    }

    .questionNoActive {
      background: #c0c0c0;
    }
  }
}

.flip-up1 {
  transform: scale(1) !important;
  opacity: 1 !important;
  transition: all 0.3s;
}

.flip-none {
  transform: scale(0.7) !important;
  opacity: 0 !important;
}
.main{
  .back-head{
    width 844px;
    margin 0 auto;
    height 30px;
    padding-top 10px
  }
  .back-icon{
    font-size: 24px;
    color #999;
    width 30px ;
    height 30px ;
    justify-content center;
    align-items center;
    display none;

    &:hover{
      background rgba(187,216,251,0.8);
      border-radius 3px;
      color #3B59F6;
      cursor pointer;

    }
  }
}

.chatRobot {
  display flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 14px;
  -webkit-font-smoothing: antialiased;
  // background: url('./image/chatBg.png') no-repeat center;
  background: #f7f7f7;

  // background: linear-gradient(to right,  #c6edff 0%,#a3c6ff 100%);
  background-size: 100% 100%;
  z-index: 1500;
  transform: scale(0.7);
  opacity: 0;

  .chatRobotHeader {
    position: fixed;
    right: 0px;
    // width: 100%;
    display: flex;
    flex-direction: row-reverse;
    cursor: pointer;
  }

  .chatRobotHeaderDiv {
    cursor: pointer;
    width: 39px;
    text-align: center;
    height: 36px;
    line-height: 36px;
  }

  .chatRobotHeaderDiv:hover {
    background: #d30038;
    color: white;
  }
}
</style>
